import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://p2pdigital.com.au';
const SITE_NAME = 'P2P Digital';
const DEFAULT_OG_IMAGE = `${SITE_URL}/images/p2p-og.png`;
const SITE_LOGO_URL = `${SITE_URL}/images/p2p-logo.png`;

const SEO = ({
  title,
  description,
  path = '',
  image,
  type = 'website',
  article,
  noindex = false,
}) => {
  const pageTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} — Medical Technology & AI Consulting`;
  const pageDescription = description || 'P2P Digital delivers expert consulting in medical device development, AI solutions, and digital health — from concept through regulatory approval to market.';
  const pageUrl = `${SITE_URL}${path}`;
  const pageImage = image || DEFAULT_OG_IMAGE;

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': type === 'article' ? 'Article' : 'WebPage',
    name: pageTitle,
    description: pageDescription,
    url: pageUrl,
    publisher: {
      '@type': 'Organization',
      name: SITE_NAME,
      logo: { '@type': 'ImageObject', url: SITE_LOGO_URL },
    },
    ...(type === 'article' && article
      ? {
          headline: title,
          datePublished: article.datePublished,
          dateModified: article.dateModified || article.datePublished,
          author: {
            '@type': 'Person',
            name: article.author,
            url: `${SITE_URL}/about`,
          },
          image: pageImage,
        }
      : {}),
  };

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={pageDescription} />
      <link rel="canonical" href={pageUrl} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDescription} />
      <meta property="og:url" content={pageUrl} />
      <meta property="og:image" content={pageImage} />
      <meta property="og:site_name" content={SITE_NAME} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={pageDescription} />
      <meta name="twitter:image" content={pageImage} />

      {/* JSON-LD */}
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
    </Helmet>
  );
};

export default SEO;
